import Vue from 'vue'
import VueMeta from 'vue-meta'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import Echo from "laravel-echo"

window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '572b2f5c05399093a0de',
    cluster: 'us2',
    forceTLS: true
});

Vue.config.productionTip = false
Vue.mixin({ methods: { route }})

InertiaProgress.init()

Vue.use(plugin)
Vue.use(VueMeta)

const el = document.getElementById('app')

Vue.filter('currency', (val) => {
    return Number(val).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
})

Vue.filter('niceTimestamp', (val) => {
    return new Date(val).toLocaleString()
})

Vue.filter('niceDate', (val) => {
    return new Date(val).toLocaleDateString('en-US', {timeZone: 'UTC'})
})

Vue.filter('niceMonthYearDate', (val) => {
    return `${new Date(val).getMonth()+1}/${new Date(val).getFullYear()}`
})

Vue.filter('niceInputDate', (val) => {
    return `${new Date(val).getFullYear()}-${new Date(val).getMonth()+1}-${new Date(val).getDate()}`
})

Vue.filter('numberInThousands', (val) => {
    return val ? Number(val).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0.00
})



Vue.prototype.$CUSTOMER_ROLE = 4;
Vue.prototype.$GIN_ROLE = 2;
Vue.prototype.$ADMIN_ROLE = 1;
Vue.prototype.$SUPER_ADMIN_ROLE = 1;

Vue.prototype.$eventBus = new Vue(); // Global event bus

new Vue({
    render: h => h(App, {
        props: {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name => require(`./Pages/${name}`).default,
        },
    }),
}).$mount(el)
